import { render } from "./WorkSpaceOrganizationDetails.vue?vue&type=template&id=1d7047ea"
import script from "./WorkSpaceOrganizationDetails.vue?vue&type=script&lang=js"
export * from "./WorkSpaceOrganizationDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__